import { Outlet } from 'react-router-dom';

import { BottomNavigation } from '../components/BottomNavigation.js';
import { Navigation } from '../components/Navigation.js';
import { useAuth } from '../contexts/AuthContext.js';
import { StoryLayout } from './StoryLayout.js';

export const PublicLayout = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-dvh bg-background">
      {/* Show navigation for all users */}
      {<Navigation />}

      <main className="mx-auto max-w-prose px-4 pb-24 grid gap-6">
        <StoryLayout>
          <Outlet />
        </StoryLayout>
      </main>

      {/* Show bottom navigation for authenticated users */}
      {isAuthenticated && <BottomNavigation />}
    </div>
  );
};
